import { createSelector } from '@reduxjs/toolkit'
import { isTrueStringMatch } from 'apps/builder/lib/utils'
import { entitiesSelector } from 'apps/formsCreationKit/store/selectors/entities'

export const pdfPageMetaSelector = createSelector(entitiesSelector, ({ pdfPageMeta }) => pdfPageMeta)

export const pdfPageMetaByPageNumberSelector = pageNumber =>
  createSelector(pdfPageMetaSelector, pdfPageMeta => {
    const meta = pdfPageMeta.find(meta =>
      isTrueStringMatch(meta.pageNumber, pageNumber)
    )
    return meta
  })
